import { Routes, Route } from "react-router-dom";

import FreeloadingListScreen from "screens/App/CRM/Freeloading/FreeloadingListScreen";
import FreeloadingCreateScreen from "screens/App/CRM/Freeloading/FreeloadingCreateScreen";
import FreeloadingEditScreen from "screens/App/CRM/Freeloading/FreeloadingEditScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";

const FreeloadingRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<FreeloadingListScreen />} />
      <Route path="create" element={<FreeloadingCreateScreen />} />
      <Route path=":id/detail" element={<ShipmentDetailScreen />} />
      <Route path=":id/edit" element={<FreeloadingEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default FreeloadingRouter;